<template>
  <b-table
    :data="clients"
    hoverable
    paginated
    :per-page="100"
    pagination-position="both"
  >
    <b-table-column
      field="user.name"
      :label="$t('clients.name')"
      sortable
      v-slot="props"
    >
      <span class="adjust-top">
        {{ getName(props.row.user) }}
        <!-- {{
          props.row.user.socialName && props.row.user.socialName.trim() != ""
            ? `${props.row.user.socialName} (${props.row.user.name} ${
                props.row.user.surname ? props.row.user.surname : ""
              })`
            : props.row.user.name +
              " " +
              (props.row.user.surname ? props.row.user.surname : " ")
        }} -->
      </span>
    </b-table-column>

    <b-table-column
      field="user.cellphone"
      :label="$t('clients.cellphone')"
      v-slot="props"
    >
      <span class="adjust-top">
        {{
          props.row.user && props.row.user.cellphone
            ? props.row.user.cellphone
            : "-"
        }}
      </span>
    </b-table-column>

    <b-table-column
      field="count"
      :label="$t('clients.totalBuys')"
      sortable
      v-slot="props"
    >
      <span class="adjust-top">
        {{ props.row.count }}
      </span>
    </b-table-column>

    <b-table-column
      field="avgSale"
      :label="$t('clients.mediumTicket')"
      sortable
      v-slot="props"
    >
      <span class="adjust-top">
        {{ `${payments.currencySymbol} ${formatMoney(props.row.avgSale)}` }}
      </span>
    </b-table-column>

    <b-table-column
      field="total"
      :label="$t('clients.total')"
      sortable
      v-slot="props"
    >
      <span class="adjust-top">
        {{
          `${payments.currencySymbol} ${formatMoney(
            props.row.avgSale * props.row.count
          )}`
        }}
      </span>
    </b-table-column>

    <b-table-column
      field="lastbuy.createdAt"
      :label="$t('clients.lastBuy')"
      sortable
      v-slot="props"
    >
      <span class="adjust-top">
        {{
          new Date(props.row.lastBuy.createdAt).toLocaleDateString(
            undefined,
            transactionDateFormat
          )
        }}
      </span>
    </b-table-column>

    <template slot="empty">
      <table-empty-template />
    </template>
  </b-table>
</template>

<script>
import { mapGetters } from "vuex";
import tableEmptyTemplate from "../../common/TableEmptyTemplate";
import { mask } from "../../../mixins/mask";

export default {
  mixins: [mask],

  props: ["clients"],

  components: {
    tableEmptyTemplate
  },

  data() {
    return {
      transactionDateFormat: {
        year: "2-digit",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      }
    };
  },

  computed: { ...mapGetters(["payments"]) },

  methods: {
    getName(user) {
      if (user) {
        return user.socialName && user.socialName.trim() != ""
          ? `${user.socialName} (${user.name} ${
              user.surname ? user.surname : ""
            })`
          : user.name + " " + (user.surname ? user.surname : " ");
      }
      return "-";
    }
  },

  mounted() {},

  destroyed() {}
};
</script>

<style>
.adjust-top {
  position: relative;
  top: 8px;
}
</style>
